import { COURSE_ACCESS_PERMISSION } from "@/components/lms/lms.utils";

const managerLmsSubRoutes = [
  {
    path: "/kaerdemy/manager/overview",
    name: "overview",
    icon: "lmsOverview",
    iconCustomConfigs: {
      strokeWidth: "1.75",
    },
    index: 6000,
    permission: COURSE_ACCESS_PERMISSION,
  },
  {
    path: "/kaerdemy/manager/courses",
    name: "course_library",
    icon: "courses",
    index: 6001,
    permission: COURSE_ACCESS_PERMISSION,
  },
  {
    path: "/kaerdemy/manager/enrolments",
    name: "course_progress",
    icon: "enrolments",
    index: 6002,
    permission: COURSE_ACCESS_PERMISSION,
  },
  {
    path: "/kaerdemy/manager/enrolmentAssignments",
    name: "enrolment_assignments",
    icon: "enrolmentAssignments",
    index: 6004,
    permission: COURSE_ACCESS_PERMISSION,
  },
];

const managerMarketingLmsSubRoutes = [
  {
    path: "/kaerdemy/manager/courses",
    name: "course_library",
    icon: "courses",
    index: 6001,
    permission: COURSE_ACCESS_PERMISSION,
  },
];

export { managerLmsSubRoutes, managerMarketingLmsSubRoutes };
